import React, { Component } from 'react';

export default class Ground extends Component {

    render() {

        let style = {};

        if (this.props.type) {
            style.backgroundImage = 'url(img/ground/'+this.props.type+')';
        }

        return (
            <div className="ground" style={style}></div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Ground.js